// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_H75t4","secondaryColumnCell":"secondary-column-cell_H75t4","name":"name_QO3C_"};